import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/pix";
import Loading from "@/atomic/atoms/Loading";

export default function CheckoutPixView({
  pixCode,
  copyCode,
  isVisibleModal,
  toggleModal,
  share,
  plate,
  codeExpiration,
  total,
  isLoading,
  error,
  tryAgain,
  pixImage,
  goBack,
}: PropsView) {
  const renderModal = () => (
    <div className="fixed flex flex-1 top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 justify-center items-start text-black h-full min-h-screen">
      <div className="relative w-full max-w-[calc(480px)] max-h-full mt-[calc(100px)]">
        <div className="relative bg-white rounded-2xl shadow p-5">
         <div className="w-full flex flex-col items-center pb-3">
            <img 
              src={process.env.PUBLIC_URL +"/icon-checked.png"}
              width={80}
              height={80}
              alt="ícone sucesso"
              className="mt-6"
            />
            <p className="self-center text-lg mt-3 font-bold mb-3">Código pix copiado</p>
            <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
            <p className="text-sm mt-2 text-center">O pagamento pode levar até 5 dias úteis para ser processado.</p>
           <button type="button" onClick={toggleModal} className="mt-3 mb-3 bg-black border p-2 rounded-lg h-[calc(60px)] text-white w-full">Entendi</button>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div className="h-full relative">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)] max-w-full">
          {error && <div className="flex w-full flex-col">
            <h2 className="text-2xl text-center font-bold">Houve um problema ao tentar gerar seu código pix</h2>
            <h3 className="text-lg text-center">Clique no botão para tentar novamente</h3>
          </div>}
          {!error && <div className="flex w-full flex-col">
            <h2 className="text-2xl font-bold">Pagamento via Pix</h2>
            <div className="mt-3 bg-white rounded-lg">
              <div className="w-full p-3">
                <p className="text-2xl font-bold">Resumo do pedido</p>
                <div className="mt-2 flex w-full">
                  <p className="text-sm w-1/2">Placa do veículo</p>
                  <p className="text-sm w-1/2 uppercase">{plate}</p>
                </div>
                <div className="mt-2 flex w-full">
                  <p className="text-sm w-1/2">Vencimento código Pix</p>
                  <p className="text-sm w-1/2">{codeExpiration}</p>
                </div>
              </div>
              {!isLoading && <div className="mt-2 flex w-full p-3 rounded-b-lg bg-green-100">
                <p className="text-lg w-1/2">Valor do pedido</p>
                <p className="text-2xl w-1/2 text-black">{total}</p>
              </div>}
            </div>
            {pixImage && <div className="mt-3 w-full flex justify-center">
              <img 
                src={`data:${pixImage?.type};base64, ${pixImage?.image}`} 
                alt="Código pix"
                className="w-80 max-h-80"
              />
            </div>}
            <p className="mt-5 text-sm">Copie o código Pix e realize o pagamento no app do seu banco ou carteira digital</p>
            <div className="rounded-lg bg-gray-200 p-3 mt-2 w-full">
              <p className="break-words text-sm">{pixCode}</p>
            </div>
          </div>}
          {error && <button type="button" onClick={tryAgain} className="mt-2 mb-6 bg-black border border-black text-white p-2 rounded-lg h-[calc(60px)] w-full flex items-center justify-center">
            Tentar novamente
          </button>}
          {!error && <div>
            <button type="button" onClick={copyCode} className="mt-6 bg-black border p-2 rounded-lg h-[calc(60px)] w-full flex items-center justify-center">
              <img
                src={process.env.PUBLIC_URL +"/icon-copy.png"}
                width={20}
                height={20}
                alt="ícone copiar"
              />
              <span className="ml-2 text-white text-base">Copiar código Pix</span>
            </button>
            <button type="button" onClick={share} className="mt-2 mb-6 bg-transparent border border-black p-2 rounded-lg h-[calc(60px)] w-full flex items-center justify-center">
              <img
                src={process.env.PUBLIC_URL +"/icon-share.png"}
                width={20}
                height={20}
                alt="ícone copiar"
              />
              <span className="ml-2 text-black text-base">Compartilhar código Pix</span>
            </button>
          </div>}
        </article>
      </main>
      {isVisibleModal && renderModal()}
      {isLoading && <Loading />}
    </div>
  );
}
